/**
 * Generated runtime TestId mirror for frontend/src/components/identity/IdentityLifecycleTimeline.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const IdentityLifecycleTimelineTestIds = {
  btnClearLifecycleFilters: "btn-clear-lifecycle-filters",
  btnToggleLifecycleFilters: "btn-toggle-lifecycle-filters",
  inputLifecycleFilterFrom: "input-lifecycle-filter-from",
  inputLifecycleFilterTo: "input-lifecycle-filter-to",
  lifecycleEventTriggerRefLink: "lifecycle-event-trigger-ref-link",
  lifecycleFiltersPanel: "lifecycle-filters-panel",
  lifecycleTimeline: "lifecycle-timeline",
  lifecycleTimelineEmpty: "lifecycle-timeline-empty",
  lifecycleTimelineError: "lifecycle-timeline-error",
  lifecycleTimelineLoading: "lifecycle-timeline-loading",
  lifecycleTimelineRows: "lifecycle-timeline-rows",
  lifecycleEvent: (event_id: string) => `lifecycle-event-${event_id}`,
  lifecycleEventPrefix: () => "lifecycle-event-" as TestIdPrefix,
  lifecycleEventTrigger: (event_id: string) => `lifecycle-event-${event_id}-trigger`,
  lifecycleEventActor: (event_id: string) => `lifecycle-event-${event_id}-actor`,
  lifecycleEventReason: (event_id: string) => `lifecycle-event-${event_id}-reason`
} as const;
